import styled from 'styled-components';
import { mediaQuery } from '@carvana/showroom-css-theme';
import Tooltip from '../../../../shared/components/Tooltip';
import QuestionMark from '../../../../shared/components/Icons/QuestionMark';
import Button from '../../shared/Button';

export const TermsOverviewWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  text-align: center;

  margin-right: 24px;
  margin-left: 24px;

  ${mediaQuery('m')} {
    margin-right: 32px;
    margin-left: 32px;
  }
`;

export const OverviewWrapper = styled.div`
  align-items: center;
  background-color: var(--cvna-color-blue-5);
  width: 100%;
  border-radius: 4px;
  padding: 20px;
`;

export const TermsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  height: 407px;
  flex-direction: column;

  ${mediaQuery('l')} {
    width: 517px;
    height: 148px;
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
  }
`;

export const TermTitle = styled.p`
  color: var(--cvna-color-grey-2);
  font-size: 14px;
  font-weight: 450;
  line-height: 16px;
  text-transform: uppercase;
  height: 16px;
  margin-bottom: 20px;

  ${mediaQuery('m')} {
    margin-bottom: 28px;
  }
`;

export const TermValue = styled.h2`
  color: var(--cvna-color-white);
  text-transform: uppercase;
  font-size: 28px;
  font-weight: 450;
  line-height: 32px;
  height: 32px;
`;

export const Terms = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  text-align: center;
  height: 120px;
`;

export const TooltipContent = styled(Tooltip.Content)`
  && {
    position: relative;
    left: 9px;
    padding: 17.5px 15px;
    padding-top: 23px;
    max-width: 250px;

    ${mediaQuery('s')} {
      padding-top: 17.5px;
    }
  }
`;

export const TooltipTitle = styled.p`
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 2px;
`;

export const TooltipBody = styled.p`
  font-size: 14px;
  font-weight: 100;
  color: #cfeaf2;
`;

export const LineBreak = styled.div`
  flex-flow: column;
  margin-bottom: 10px;
  width: 207px;
  border-bottom: 1px solid var(--cvna-color-blue-4);
  border-right: 0;

  ${mediaQuery('m')} {
    border-right: 1px solid var(--cvna-color-blue-4);
    height: 78px;
    border-bottom: 0;
    width: 0;
  }
`;

export const Symbol = styled.span`
  font-size: 26px;
  font-weight: 700;
  width: 21px;
  height: 26px;
  vertical-align: 0.32em;
  line-height: 26px;
`;

export const Question = styled(QuestionMark)`
  margin: 0px 0px -3px 5px;
`;

export const Months = styled(Symbol)`
  vertical-align: 0.05em;
  text-transform: lowercase;
`;

export const GetStartedTopText = styled.h2`
  font-size: 20px;
  color: var(--cvna-color-blue-6);
  text-transform: uppercase;
  margin-bottom: 0.25em;
  font-weight: bold;
  margin-top: 1em;
  padding: 0;
`;

export const GetStartedBottomText = styled.p`
  font-size: 28px;
  color: var(--cvna-color-blue-6);
  font-weight: bold;
  line-height: 1.2;
  margin-top: 0;
  text-transform: uppercase;
  padding: 0;
`;

export const BrowseContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;

  ${mediaQuery('m')} {
    margin-top: 4rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
`;

export const BrowseTextContainer = styled.div`
  text-align: center;
  align-items: center;

  ${mediaQuery('m')} {
    text-align: left;
  }
`;

export const BrowseButton = styled(Button)`
  height: 56px;
  width: 200px;
  margin: 2.5rem 0;
  padding: 1rem 0;

  ${mediaQuery('s')} {
    width: 300px;
  }
`;

/* TODO(josh): Position divider on percentage of parent container not margin-left.
   looks ok at 375 but weird at other view widths until media query. */
export const SearchDivider = styled.div`
  background-color: var(--cvna-color-yellow-2);
  height: 0.5rem;
  width: 4rem;
  margin-top: 2.5em;
  margin-left: 8.5rem;

  ${mediaQuery('m')} {
    margin-left: 0;
  }
`;
